/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
// question/:qpage
const paths = {
  "root": {
    "path": "/",
    "id": -1,
    "needToken": false
  },
  "logon": {
    "path": "/logon",
    "id": -1,
    "needToken": false
  },
  "help": {
    "path": "/help",
    "id": -1,
    "needToken": false
  },
  "agreement": {
    "path": "/agreement",
    "id": 1,
    "needToken": true
  },
  "accountQuestion": {
    "path": "/accountQuestion",
    "id": 1,
    "needToken": true
  },
  "previewQuestion": {
    "path": "/previewQuestion",
    "id": 1,
    "needToken": true
  },
  "basicInfo": {
    "path": "/basicInfo",
    "id": 1,
    "needToken": true
  },
  "appointment": {
    "path": "/appointment",
    "id": 1,
    "needToken": true
  },
  "aoFormHome": {
    "path": "/aoFormHome",
    "id": 1,
    "needToken": true
  },
  "result_page": {
    "path": "/result_page",
    "id": 1,
    "needToken": true
  },
  "aoform": {
    "static_path": "/aoform/:id",
    path: (formId) => `/aoform/${formId}`,
    "id": 1,
    "needToken": true
  },
  "confirmPQ": {
    "path": "/confirmPQ",
    "id": 1,
    "needToken": true
  },
  "file_upload": {
    "path": "/file_upload",
    "id": 1,
    "needToken": true
  },
  "file_upload_info": {
    "static_path": "/file_upload_info/:id",
    path: (id) => `/file_upload_info/${id}`,
    "id": 1,
    "needToken": true
  },
  "applicantInformation": {
    "path": "/applicantInformation",
    "id": 1,
    "needToken": true
  },
  "companyRegistration": {
    "path": "/companyRegistration",
    "id": 1,
    "needToken": true
  },
  "accountOpeningSteps": {
    "path": "/accountOpeningSteps",
    "id": 1,
    "needToken": true
  },
  "dashboard": {
    "path": "/dashboard",
    "id": 1,
    "needToken": true
  },
  "systemErrorMessage": {
    "path": "/systemErrorMessage",
    "id": 1,
    "needToken": false
  }
};

export default paths



// WEBPACK FOOTER //
// ./src/config/path.js